import {precisionCalculation} from 'shared/web';

/** Decimal places a number is written with, including exponent notation (1e-7 has 7). */
const getDecimalPlaces = (value: number) => {
  const [mantissa, exponent = '0'] = value.toString().split('e');

  return Math.max(0, (mantissa.split('.')[1]?.length ?? 0) - Number(exponent));
};

/**
 * @description
 * Returns round value by step or nearest step in array by value.
 * A fractional step result is rounded to the step's decimal places to drop floating point drift.
 *
 * @param {number} value - value for rounding
 * @param {number | number[]} step - step value or array
 *
 * @example
 * // return 1
 * roundToStep(0.9, 1);
 *
 * // return 1
 * roundToStep(1.9, [1, 5, 10]);
 *
 * // return 0.15, not 0.15000000000000002
 * roundToStep(0.16, 0.05);
 */

export const roundToStep = (value: number, step: number | number[]) => {
  if (Array.isArray(step)) {
    return step.reduce((prev, curr) =>
      Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev
    );
  }

  return precisionCalculation.round(Math.round(value / step) * step, getDecimalPlaces(step));
};
